import React, { createContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { setGlobalCSSVariables } from "../utils";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { theme = false, content = false } =
    useSelector((state) => state?.uiConfig?.uiConfigData) || {};

  useEffect(() => {
    if (content && theme) {
      setGlobalCSSVariables(content, theme);
    }
  }, [content, theme]);

  return (
    <ThemeContext.Provider value={content}>{children}</ThemeContext.Provider>
  );
};
